import styled, { css } from 'styled-components';
import { Box } from 'modules/Box';
import { pxToRem } from 'modules/spacing';
import { themeGet, themeGetColor } from 'modules/tetrisTheme';
const disabledStyles = css `
  background-color: transparent;

  & * > * {
    color: ${themeGet('colors.disabled.200')};
  }
`;
const selectedStyles = css `
  background-color: ${themeGet('colors.primary.50')};

  &:hover {
    background-color: ${themeGet('colors.primary.50')};
  }

  > [data-icon='falcon'] {
    color: ${themeGet('colors.primary.1000')};
  }
`;
export const ListItemContainerInner = styled.div.attrs((props) => (Object.assign(Object.assign({}, props), { as: props.onClick ? 'button' : props.as }))) `
  display: flex;
  flex-grow: 1;
  min-width: 0;
  align-items: center;
  justify-content: flex-start;
  gap: ${themeGet('spacing.md')};
  padding: ${themeGet('spacing.md')};

  &:is(button, a):not(:disabled, [disabled]) {
    cursor: pointer;
  }

  ${({ disabled }) => disabled && disabledStyles};
  ${({ $selected, disabled }) => $selected && !disabled && selectedStyles};
`;
export const ListItemContainer = styled.div `
  display: flex;
  flex-shrink: 0;
  align-items: center;
  width: 100%;
  user-select: none;
  border: none;
  outline: ${themeGet('spacing.sm')} solid transparent;
  background-color: ${themeGet('colors.background.50')};
  border-radius: ${themeGet('borderRadius.md')};
  text-align: left;
  color: ${themeGet('colors.text.300')};
  font-size: ${themeGet('fontSize.medium')};
  font-weight: ${themeGet('fontWeight.regular')};
  text-decoration: none;
  line-height: 1;
  transition-duration: 0.2s;
  transition-property: border, background-color, outline;
  transition-timing-function: ease-out;

  /* Only apply hover styles to clickable/tabbable elements */
  &:hover:not(:disabled, [disabled]):has([role='button'], button, a, label) {
    background-color: ${themeGet('colors.primary.50')};

    ${ListItemContainerInner} > [data-icon='falcon'] {
      color: ${themeGet('colors.primary.1000')};
    }
  }

  &:focus-visible {
    box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.primary')};
  }

  &:active:not(:disabled, [disabled]):is([role='button'], button, a, label) {
    background-color: ${themeGet('colors.focus.primary')};
  }

  ${ListItemContainerInner} > [data-icon='falcon'] {
    width: ${pxToRem(16)};
    height: ${pxToRem(16)};
    color: ${themeGet('colors.primary.500')};
  }

  ${({ $selected, disabled }) => $selected && !disabled && selectedStyles};
`;
export const List = styled.section `
  display: flex;
  flex-direction: column;
  background-color: ${themeGet('colors.background.50')};
  gap: ${themeGet('spacing.sm')};
`;
export const ListItemDivider = styled.hr `
  flex-shrink: 0;
  border: none;
  margin: ${themeGet('spacing.xs')} ${themeGet('spacing.md')};
  height: ${pxToRem(1)};
  background-color: ${themeGetColor('border.100', 0.5)};
`;
export const StickyHeaderContainer = styled(Box) `
  position: ${(props) => (props.$sticky ? 'sticky' : 'relative')};
  top: 0;
  z-index: ${(props) => (props.$sticky ? '2' : '1')};
  background-color: ${themeGetColor('gray.0')};
`;
export const HeaderActions = styled.div `
  margin-left: auto;
`;
export const StickyFooterContainer = styled(Box) `
  position: ${(props) => (props.$sticky ? 'sticky' : 'relative')};
  bottom: 0;
  background-color: ${themeGet('colors.gray.0')};
`;
export const ListItemActions = styled.div `
  display: flex;
  overflow: hidden;
  margin-left: auto;
  margin-right: ${themeGet('spacing.md')};
`;
